"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CueBar = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("@tippyjs/react"));
var code_block_1 = __importDefault(require("./code-block"));
var video_context_1 = require("../context/video-context");
var react_2 = require("@xstate/react");
var selectors_1 = require("../selectors");
var use_cue_1 = require("../hooks/use-cue");
var react_markdown_1 = __importDefault(require("react-markdown"));
var use_metadata_cues_1 = require("../hooks/use-metadata-cues");
var time_1 = require("@skillrecordings/time");
var CueBar = function (_a) {
    var className = _a.className, disableCompletely = _a.disableCompletely, player = _a.player, actions = _a.actions;
    var videoService = (0, video_context_1.useVideo)();
    var duration = (0, react_2.useSelector)(videoService, selectors_1.selectDuration);
    var cues = (0, use_metadata_cues_1.useMetadataCues)();
    return disableCompletely ? null : (React.createElement("div", { className: (0, classnames_1["default"])('cueplayer-react-cue-bar', className) }, cues.map(function (noteCue, i) {
        return (React.createElement(NoteCue, { key: "".concat(noteCue.text, "-").concat(i), cue: noteCue, duration: duration, player: player, actions: actions }));
    })));
};
exports.CueBar = CueBar;
var NoteCue = function (_a) {
    var cue = _a.cue, duration = _a.duration, className = _a.className;
    var videoService = (0, video_context_1.useVideo)();
    var viewer = (0, react_2.useSelector)(videoService, selectors_1.selectViewer);
    (0, use_cue_1.useCue)(cue);
    var clickOpen = function () {
        // if we seek to the correct time, the note is displayed
        videoService.send('PAUSE');
        videoService.send({
            type: 'SEEKING',
            seekingTime: Number(cue.startTime),
            source: 'cue'
        });
        videoService.send('END_SEEKING');
        // track('opened cue', {cue: cue.text})
    };
    var startPosition = "".concat((cue.startTime / duration) * 100, "%");
    var note;
    try {
        note = JSON.parse(cue.text);
    }
    catch (e) {
        note = { text: cue.text };
    }
    var customRenderers = {
        code: function (props) {
            return React.createElement(code_block_1["default"], __assign({}, props));
        }
    };
    return (React.createElement(react_1["default"], { placement: "top", maxWidth: 300, appendTo: "parent", offset: [0, 12], interactive: true, duration: 400, trigger: "mouseenter focus", delay: 20, inertia: true, content: React.createElement("div", { id: cue.startTime, className: "cueplayer-react-cue-popup-content" },
            React.createElement("div", { className: "cueplayer-react-cue-popup-body" },
                React.createElement(react_markdown_1["default"], { renderers: customRenderers }, note.text))) },
        React.createElement("button", { "aria-label": "jump to note at ".concat((0, time_1.convertTimeWithTitles)(cue.startTime, {
                showSeconds: true,
                longForm: true
            })), "aria-describedby": cue.startTime, type: "button", onClick: clickOpen, className: (0, classnames_1["default"])("".concat(note.type === 'learner'
                ? 'cueplayer-react-cue-note-learner'
                : 'cueplayer-react-cue-note'), className), style: {
                left: startPosition,
                backgroundImage: "url(".concat(note.image || viewer.avatar_url, ")"),
                backgroundColor: note.image ? 'transparent' : "#b8c1cf",
                border: '1px solid #20222b',
                // border: note.image ? 'none' : '1px solid #20222b',
                backgroundSize: 'contain'
            } })));
};
